import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const IconYes = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24.3306 12.9998C24.3306 18.9812 19.4817 23.8301 13.5002 23.8301C7.51882 23.8301 2.66992 18.9812 2.66992 12.9998C2.66992 7.01833 7.51882 2.16943 13.5002 2.16943C19.4817 2.16943 24.3306 7.01833 24.3306 12.9998ZM19.1404 10.5159C19.563 10.0927 19.5624 9.40693 19.1392 8.9843C18.7159 8.56168 18.0302 8.5622 17.6075 8.98548L11.3336 15.269L8.85095 12.7863C8.428 12.3634 7.74226 12.3634 7.31931 12.7863C6.89636 13.2093 6.89636 13.895 7.31931 14.318L10.5684 17.5671C10.7716 17.7703 11.0473 17.8844 11.3346 17.8843C11.622 17.8842 11.8976 17.7698 12.1006 17.5665L19.1404 10.5159Z"
                fill="#30BF00"
            />
        </svg>
    );
};

const IconNo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.5002 23.8301C19.4817 23.8301 24.3306 18.9812 24.3306 12.9998C24.3306 7.01833 19.4817 2.16943 13.5002 2.16943C7.51882 2.16943 2.66992 7.01833 2.66992 12.9998C2.66992 18.9812 7.51882 23.8301 13.5002 23.8301ZM17.5152 8.98489C17.9382 9.40784 17.9382 10.0936 17.5152 10.5165L15.0319 12.9998L17.5152 15.4831C17.9382 15.906 17.9382 16.5918 17.5152 17.0147C17.0923 17.4377 16.4065 17.4377 15.9836 17.0147L13.5003 14.5314L11.017 17.0147C10.5941 17.4377 9.90833 17.4377 9.48538 17.0147C9.06243 16.5918 9.06243 15.906 9.48538 15.4831L11.9687 12.9998L9.48538 10.5165C9.06243 10.0936 9.06243 9.40784 9.48538 8.98489C9.90833 8.56194 10.5941 8.56194 11.017 8.98489L13.5003 11.4682L15.9836 8.98489C16.4065 8.56194 17.0923 8.56194 17.5152 8.98489Z"
                fill="#FA4500"
            />
        </svg>
    );
};

export default function E() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('powerstreamcooperation');
    const { locale } = useRouter();
    const WHITE_SITES: string[] = ['fr', 'it', 'es'];

    return (
        <div className={`powerstream-cooperation-E ${css['powerstream-cooperation-E']}`}>
            <p className="title">{t('secE_title')}</p>
            <EFPicture
                src={`/responsive/picture/powerstream-cooperation/5_1366${WHITE_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                srcPad={`/responsive/picture/powerstream-cooperation/5_768${WHITE_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                srcMobile={`/responsive/picture/powerstream-cooperation/5_375${WHITE_SITES.includes(locale) ? `_${locale}` : ''}.jpg`}
                alt={t('secE_title')}
            />
            <table>
                <thead>
                    <tr className="gray">
                        <th></th>
                        <th>{t('secE_text1')}</th>
                        <th>{t('secE_text2')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{t('secE_text3')}</td>
                        <td>
                            <IconYes />
                        </td>
                        <td>
                            <IconNo />
                        </td>
                    </tr>
                    <tr className="gray">
                        <td>{t('secE_text4')}</td>
                        <td>
                            <IconYes />
                        </td>
                        <td>
                            <IconNo />
                        </td>
                    </tr>
                    <tr>
                        <td>{t('secE_text5')}</td>
                        <td>
                            <IconYes />
                        </td>
                        <td>
                            <IconNo />
                        </td>
                    </tr>
                    <tr className="gray">
                        <td>{t('secE_text6')}</td>
                        <td>
                            <IconYes />
                        </td>
                        <td>
                            <IconYes />
                        </td>
                    </tr>
                    <tr style={{ borderBottom: '2px solid #f4f4f4' }}>
                        <td>{t('secE_text7')}</td>
                        <td>
                            <IconYes />
                        </td>
                        <td>
                            <IconNo />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
